// these must be in their own file and loaded into the src/index.js entry point in contrast to having these statements directly
// invoked from the main entry point. For more information visit: https://docs.logrocket.com/v1.0/docs/troubleshooting-sessions
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer';
import config from './config/config';

const privateFieldNames = ['ssn', 'password'];

const { requestSanitizer, responseSanitizer } = LogrocketFuzzySanitizer.setup([
  ...privateFieldNames
]);

const APP_IDS = {
  development: 'aorusa/ireport-react-app-local',
  test: 'aorusa/ireport-react-app-test',
  stage: 'aorusa/ireport-react-app-stage',
  uat: 'aorusa/ireport-react-app-uat',
  production: 'aorusa/ireport-react-app-prod'
};

let hasInit = false;

export function initLogRocket() {
  if (hasInit) return;

  const appId = APP_IDS[config.name];
  if (!appId) return;

  LogRocket.init(appId, {
    network: { requestSanitizer, responseSanitizer }
  });

  setupLogRocketReact(LogRocket);
  hasInit = true;
}

//leaving this in for now

// if (config.name === 'development') {
//   LogRocket.init('aorusa/ireport-react-app-local', {
//     network: { requestSanitizer, responseSanitizer }
//   });
// }
// if (config.name === 'test') {
//   LogRocket.init('aorusa/ireport-react-app-test', {
//     network: { requestSanitizer, responseSanitizer }
//   });
// }
// if (config.name === 'stage') {
//   LogRocket.init('aorusa/ireport-react-app-stage', {
//     network: { requestSanitizer, responseSanitizer }
//   });
// }
// if (config.name === 'uat') {
//   LogRocket.init('aorusa/ireport-react-app-uat', {
//     network: { requestSanitizer, responseSanitizer }
//   });
// }
// if (config.name === 'production') {
//   LogRocket.init('aorusa/ireport-react-app-prod', {
//     network: { requestSanitizer, responseSanitizer }
//   });
// }

// setupLogRocketReact(LogRocket);
